import React from 'react';
import { Instagram, Shield, Info } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-border/50 py-12 px-4">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Brand Column */}
            <div className="md:col-span-2 space-y-4">
              <h3 className="text-2xl font-bold gradient-text">Meta Learners</h3>
              <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
                Your trusted partner for premium subscriptions at smarter prices. 
                Pay only after activation with full support every step of the way.
              </p>
              <div className="flex gap-4 items-center">
                <a
                  href="https://www.instagram.com/metalearners.shop"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-primary hover:text-primary-glow transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                  <span className="text-sm font-medium">@meta_learners</span>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-4">
              <h4 className="text-sm font-bold text-foreground uppercase tracking-wider">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <button
                    onClick={() => document.getElementById('offers')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    Browse Offers
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    How It Works
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('trust')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    Why Trust Us
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    FAQ
                  </button>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div className="space-y-4">
              <h4 className="text-sm font-bold text-foreground uppercase tracking-wider">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Terms of Service
                  </button>
                </li>
                <li>
                  <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Refund Policy
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="pt-8 border-t border-border/50 space-y-4">
            <div className="bg-warning/10 border border-warning/30 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <Info className="w-5 h-5 text-warning flex-shrink-0 mt-0.5" />
                <div className="space-y-1">
                  <p className="text-sm font-semibold text-foreground">Important Disclaimer</p>
                  <p className="text-xs text-muted-foreground leading-relaxed">
                    Meta Learners is an independent service and is not affiliated with, endorsed by, or partnered 
                    with any of the brands, services, or companies shown on this website (including but not limited 
                    to YouTube, Apple, Crunchyroll, Netflix, Spotify, Disney+, HBO Max, or Paramount+). All brand 
                    names, logos, and trademarks are property of their respective owners. Offers are subject to 
                    availability, eligibility requirements, and may vary by region.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Shield className="w-4 h-4" />
              <span>
                All transactions are secure and protected. We prioritize your privacy and account safety.
              </span>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-8 text-center">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Meta Learners. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
